import { CommonModule } from '@angular/common'
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { ServerRepresentedEvent } from '@app/modules/events/models/event.model'
import { Persona } from '@app/modules/personas/interfaces/persona.interface'
import { environment } from '@environments/environment'

@Component({
  selector: 'ngx-landing-registration',
  templateUrl: './landing-registration.component.html',
  styleUrls: ['./landing-registration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class LandingRegistrationComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() event: ServerRepresentedEvent
  @Input() persona: Persona

  private listener: (event: MessageEvent) => void
  registrationLink: SafeUrl
  @ViewChild('iframe') iframe: ElementRef

  constructor(private auth: AuthService, private _sanitizer: DomSanitizer) {}

  /**
   * Listen to the iframe height message and set the iframe height accordingly
   * @returns void
   */
  ngAfterViewInit(): void {
    this.listener = (event) => {
      if (event.data?.height) this.iframe.nativeElement.style.height = event.data.height + 'px'
    }
    window.addEventListener('message', this.listener)
  }

  /**
   * Remove the iframe height listener
   * @returns void
   */
  ngOnDestroy(): void {
    window.removeEventListener('message', this.listener)
  }

  ngOnChanges() {
    const url = `${environment.publicFormsUrl}workspaces/${this.auth.currentWorkspace.slug}/events/${this.event.slug}/forms/${this.persona.slug}`
    this.registrationLink = this._sanitizer.bypassSecurityTrustResourceUrl(url)
  }
}
